import React from 'react';
import {
    Show,
    TextField,
    BooleanField,
    SimpleShowLayout
} from 'react-admin';

// own ui
import CustomImageField from '../../ui/custom-image-field';

const ThemeCuriosityShow = props => (
    <Show
      title="Curiosidade" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <CustomImageField source="image_cover" label="Imagem" showAll={true} sortable={false}/>
            <TextField source="theme_name" label="Tema" sortable={false} />
            <TextField source="city_name" label="Cidade" sortable={false} />
            <TextField source="title.pt_br" label="Título PT-BR" sortable={false} />
            <TextField source="title.en_us" label="Título EN-US" sortable={false} />
            <TextField source="description.pt_br" label="Descrição PT-BR" sortable={false} />
            <TextField source="description.en_us" label="Descrição EN-US" sortable={false} />
            <BooleanField source="active" label="Ativo" sortable={false} />
        </SimpleShowLayout>
    </Show>
);

export default ThemeCuriosityShow;
